import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { publicProfileApi } from '../services/api';
import LoadingSpinner from '../components/LoadingSpinner';
import PublicProfileView from '../components/profile/PublicProfileView';

const PublicProfilePage = () => {
  const { readerId } = useParams();
  const [scope, setScope] = useState('season');
  const [profile, setProfile] = useState(null);
  const [status, setStatus] = useState('loading'); // loading | ready | missing | error

  useEffect(() => {
    let cancelled = false;
    setStatus('loading');
    publicProfileApi.getProfile(readerId, { scope })
      .then((res) => {
        if (cancelled) return;
        setProfile(res.data.profile);
        setStatus('ready');
      })
      .catch((error) => {
        if (cancelled) return;
        const code = error.response?.status;
        setStatus(code === 404 || code === 400 ? 'missing' : 'error');
      });
    return () => { cancelled = true; };
  }, [readerId, scope]);

  useEffect(() => {
    if (profile?.reader?.name) document.title = `${profile.reader.name} · Read the Word`;
  }, [profile]);

  if (status === 'loading' && !profile) return <LoadingSpinner />;

  if (status === 'missing') {
    return (
      <div className="public-profile-empty">
        <h1>This profile isn't public</h1>
        <p>The reader may not exist, or they haven't turned on competitive mode.</p>
        <Link to="/">Back to Read the Word</Link>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="public-profile-empty">
        <h1>Couldn't load this profile</h1>
        <p>Please try again in a moment.</p>
      </div>
    );
  }

  return <PublicProfileView profile={profile} scope={scope} onScopeChange={setScope} />;
};

export default PublicProfilePage;
